<template src="./contact.html">
    
</template>

<script>
import * as emailjs from 'emailjs-com'
import axios from 'axios'

export default {
    data(){
        return{
            templateParams : {
                name: '',
                company:'',
                message:'',
                email:'',
                phone:''
            },
            templateID:'template_AgqAeNfg',
            serviceID:'default_service',
            user_ID:'user_heeDpewGsmzxZHahLTbMV',
            messageSent:false,
            errorMessage:false,
            loader:false,
        }
    },

    methods:{

        reset() {
            this.templateParams = {
                name: null,
                company:null,
                message:null,
                email:null,
                phone:null
            } 
            this.errors.clear();

            setInterval( () => {
                this.errors.clear();
            })
        },

        sendJamez(){
            axios
            .post('http://localhost:3000/send', this.templateParams)
            .then(response =>  console.log(response) )
        },

        emailGun(){
            let bdy ={
                    "from": "Excited User <james.i@comsoftltd.com>",
                    "to": "james.i@comsoftltd.com",
                    'name':'James Iniobong',
                    "subject": "Hello",
                    "text": "Testing some Mailgun awesomness!"
                }
            const body = JSON.stringify(bdy)
            return fetch("https://api.mailgun.net/v3/sandbox605c2f2b81a74d808c895138af18f60f.mailgun.org/",{
                method:"POST",
                withCredentials: true,
                // credentials: 'omit',
                headers: {
                    'Authorization': {'api':'28716d5cd87cfdfaa3eba996e6848b41-19f318b0-7287bfcd'},
                    'api': '28716d5cd87cfdfaa3eba996e6848b41-19f318b0-7287bfcd', //it can be iPhone or your any other attribute
                    'Content-Type': 'application/json'
                },
                mode:'no-cors',
                // auth:{"api": "19f318b0-7287bfcd"},
                data:body
            }).then( res => {
                console.log(res);
            })
        },


        sendMail(){
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loader = true;
                    emailjs.send(this.serviceID,this.templateID, this.templateParams,this.user_ID)
                    .then((response) => {
                        this.messageSent = true;
                        this.loader = false;
                        this.reset()                       
                        setInterval( () =>{
                            this.messageSent = false
                        }, 6000)
                    }, error => {
                        // console.log("Error, bases");
                        this.errorMessage = true
                        this.loader = false;
                        this.reset()
                        setInterval( () =>{
                            this.errorMessage = false
                        }, 12000)
                    });
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/contact/contact.vue